import { UnauthorizedError } from "@/gateways/apiClient";
import { meGateway } from "@/gateways/meGateway";
import { useQuery } from "@tanstack/vue-query";

export function useGetMe(
  callbacks: { onSuccess?: () => void; onUnauthorizedError?: () => void } = {},
) {
  const query = useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        const me = await meGateway.getMe();
        if (callbacks.onSuccess) callbacks.onSuccess();
        return me;
      } catch (err) {
        if (err instanceof UnauthorizedError) {
          if (callbacks.onUnauthorizedError) callbacks.onUnauthorizedError();
        }
        throw err;
      }
    },
  });

  return { ...query, getMeStatus: query.status, me: query.data };
}
